import React from 'react';
import { connect } from 'dva';
import InvitationCard from './InvitationCard';
import { EmailInvitationHeaderImg, EmailInvitationPlaceholder, setEmailList } from './util';
import ABSMessage from '../../ABSMessage';
import ABSInput from '../../ABSInput';
import { isPass } from '../../../utils/Validator';

export interface IEmailInvitationProps {
  dispatch?: any;
}
 
export interface IEmailInvitationState {
  content: string;
}

class EmailInvitation extends React.Component<IEmailInvitationProps, IEmailInvitationState> {
  invitationField: ABSInput | null;
  constructor(props: any) {
    super(props);
    this.state = {
      content: ''
    };
  }
  renderInputContent() {
    const { content } = this.state;
    return (
      <ABSInput 
        className="abs-invitation-content-input" 
        height={180} 
        type="textarea"
        defaultValue={content} 
        placeholder={EmailInvitationPlaceholder}
        ref={view => this.invitationField = view} 
        required={true}
      />
    );
  }

  onInvitationClick = () => {
    const validateResult  = isPass(this.invitationField);
    if (!validateResult) {
      return;
    }
    const content = this.invitationField ? this.invitationField.getValue() : '';
    const emailList = setEmailList(content);
    this.props.dispatch({
      type: 'global/emailInvitation',
      payload: {
        emails: emailList
      },
    }).then((res) => {
      if (res) {
        if (res.success_count) {
          ABSMessage.success('邀请发送成功，好友注册成功即可获得积分');
        }
        let errorDetail = (res.wrong_emails).join(',');
        this.setState({ content: errorDetail });
        if (res.wrong_emails.length) {
          ABSMessage.error('部分邮箱发送失败，请检查邮箱地址是否正确');
        }
      }
    });
  }

  render() { 
    const footBtn = {
      title: '发送邀请',
      icon: 'send',
      onClick: () => this.onInvitationClick(),
    };
    return (
      <InvitationCard
        headerImg={EmailInvitationHeaderImg}
        headerTitle="邮件邀请"
        title="直接邀请邮箱联系人加入CNABS"
        content={this.renderInputContent()}
        footBtn={footBtn}
      />
     );
  }
}

function mapStateToProps(state: any) {
  return { ...state.global };
}

export default connect(mapStateToProps)(EmailInvitation);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSHeader/ABSInvitation/EmailInvitation.tsx